import { render, staticRenderFns } from "./TemplateDetails.vue?vue&type=template&id=7dba7cbe&scoped=true"
import script from "./TemplateDetails.vue?vue&type=script&lang=js"
export * from "./TemplateDetails.vue?vue&type=script&lang=js"
import style0 from "./TemplateDetails.vue?vue&type=style&index=0&id=7dba7cbe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dba7cbe",
  null
  
)

export default component.exports